/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { IFilterMachineData } from 'utilities/MachinesFilter';
import { actions } from '../actionTypes';

export const initialMachineFilterState: IFilterMachineData = {
  halls: 'all',
  onlineOnly: false,
  showDetails: true,
  showFavourites: false,
  show: 'list',
  searchValue: '',
  Specification: 'all',
  ParentId: 'all',
};

const initialAllMachineFilterState: IFilterMachineData = {
  halls: 'all',
  onlineOnly: false,
  showDetails: true,
  showFavourites: false,
  show: 'list',
  searchValue: '',
  Specification: 'all',
  ParentId: 'all',
};

interface IFilterMachineStates {
  all: IFilterMachineData;
  initial: IFilterMachineData;
}

export const initialMachineFilterStates: IFilterMachineStates = {
  initial: initialMachineFilterState,
  all: initialAllMachineFilterState,
};

const machineListFilters = (
  state: IFilterMachineStates = initialMachineFilterStates,
  action,
): IFilterMachineStates | undefined => {
  switch (action.type) {
    case actions.SET_MACHINE_FILTER: {
      const key = `${action.payload.filter.fairTag}`;
      if (state[key]) {
        state[key] = {
          ...state[key],
          ...action.payload.filter,
        };
      } else {
        state[key] = {
          ...state.initial,
          ...action.payload.filter,
        };
      }
      // "Hack", reassignment is necessary, otherwise the storage is not updatet.
      return {
        ...state,
        [key]: state[key],
      };
    }

    default: {
      return state;
    }
  }
};

export default machineListFilters;
